document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('form[action="/cart/add"]');

  if (!forms.length) return;

  forms.forEach(function (form) {
    var lengthInput = form.querySelector('[data-length-input]');
    var lengthProperty = form.querySelector('[data-length-property]');
    var message = form.querySelector('[data-length-message]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var addToCartButton = form.querySelector('button[type="submit"][name="add"], button[type="submit"]');

    if (!lengthInput || !lengthProperty || !message || !quantityInput) return;

    var maxAvailable = parseInt(message.dataset.maxAvailable || '0', 10);
    var unitPrice = parseFloat(message.dataset.unitPrice || '0.5');

    function formatMoney(value) {
      return '$' + value.toFixed(2);
    }

    function setButtonState(enabled) {
      if (!addToCartButton) return;

      addToCartButton.disabled = !enabled;
      addToCartButton.classList.toggle('disabled', !enabled);
      addToCartButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }

    function getSectionSuffix() {
      var formId = String(form.getAttribute('id') || '');
      var prefix = 'product-form-';

      if (formId.slice(0, prefix.length) !== prefix) return '';

      return formId.slice(prefix.length);
    }

    function getPriceWrappers() {
      var suffix = getSectionSuffix();
      if (!suffix) return [];

      var wrappers = [];
      var mainPrice = document.getElementById('price-' + suffix);
      var stickyPrice = document.getElementById('price-Sticky-' + suffix);

      if (mainPrice) wrappers.push(mainPrice);
      if (stickyPrice) wrappers.push(stickyPrice);

      return wrappers;
    }

    function collectPriceElements(selector) {
      var wrappers = getPriceWrappers();
      var elements = [];

      wrappers.forEach(function (wrapper) {
        var found = wrapper.querySelectorAll(selector);
        found.forEach(function (el) {
          elements.push(el);
        });
      });

      return elements;
    }

    function getRegularPriceEls() {
      return collectPriceElements('.price__regular .price-item--regular');
    }

    function getSalePriceEls() {
      return collectPriceElements('.price__sale .price-item--sale');
    }

    function getOriginalTexts(elements) {
      return elements.map(function (el) {
        return el.textContent.trim();
      });
    }

    function updateDisplayedPrice(total) {
      var formatted = formatMoney(total);
      var regularPriceEls = getRegularPriceEls();
      var salePriceEls = getSalePriceEls();

      regularPriceEls.forEach(function (el) {
        el.textContent = formatted;
      });

      salePriceEls.forEach(function (el) {
        el.textContent = formatted;
      });
    }

    var originalRegularTexts = getOriginalTexts(getRegularPriceEls());
    var originalSaleTexts = getOriginalTexts(getSalePriceEls());

    function resetDisplayedPrice() {
      var regularPriceEls = getRegularPriceEls();
      var salePriceEls = getSalePriceEls();

      regularPriceEls.forEach(function (el, index) {
        el.textContent = originalRegularTexts[index] || '$0.50';
      });

      salePriceEls.forEach(function (el, index) {
        el.textContent = originalSaleTexts[index] || '$0.50';
      });
    }

    function invalidateState(errorMessage) {
      lengthProperty.value = '';
      quantityInput.value = 1;
      message.textContent = errorMessage || '';
      resetDisplayedPrice();
      setButtonState(false);
      return false;
    }

    function validateAndSync() {
      var rawValue = lengthInput.value.trim();

      if (!rawValue) {
        return invalidateState('');
      }

      var length = parseInt(rawValue, 10);

      if (isNaN(length)) {
        return invalidateState('Please enter a valid whole number.');
      }

      if (maxAvailable <= 0) {
        return invalidateState('This product is currently unavailable. Please contact (305) 542-5752 for more information.');
      }

      if (length < 12) {
        return invalidateState('Minimum order length is 12 inches.');
      }

      if (length > maxAvailable) {
        return invalidateState('Requested length exceeds today’s available capacity. Please contact (305) 542-5752 for more information.');
      }

      quantityInput.value = length;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

      lengthProperty.value = String(length);

      var total = length * unitPrice;

      updateDisplayedPrice(total);

      message.textContent =
        'Total: ' + formatMoney(total) + ' · Available today: ' + maxAvailable + ' inches';

      setButtonState(true);
      return true;
    }

    lengthInput.addEventListener('input', validateAndSync);
    lengthInput.addEventListener('change', validateAndSync);

    form.addEventListener('submit', function (event) {
      var ok = validateAndSync();

      if (!ok) {
        event.preventDefault();
        event.stopPropagation();
        lengthInput.focus();
      }
    });

    setButtonState(false);
    validateAndSync();
  });
});